export function setPreloader (state, preloader) {
    state.preloader = preloader
}
